import axios, { AxiosError, AxiosResponse } from 'axios'
import { toast } from 'react-toastify';
import { Activity, ActivityFormValues } from '../models/activity';
import { UserActivity2 } from '../models/userActivity2';
import { PaginatedResponse } from '../models/paginatedResponse';
import { Photo } from '../models/photo';
//import { UserActivity, ProfileFormValues } from '../models/profile';
import { UserActivity } from '../models/userActivity';
import { User, UserFormValues } from '../models/user';
import { router } from '../router/Routes';
import { store } from '../stores/store';

//const sleep = () => new Promise(resolve => setTimeout(resolve, 500)); //'k
const sleep = (delay: number) => {
    return new Promise((resolve) => { //' the way we deal with asynchronous code in javascript is to use promises 
        setTimeout(resolve, delay)
    }) 
}

// axios.interceptors.response.use(response => {
//     return sleep(1000).then(() => {
//         return response;
//     }).catch((error) => {
//         console.log(error);
//         return Promise.reject(error);
//     })
// })

axios.interceptors.response.use(async response => {
    // try {
    //     await sleep(1000);
    //     return response;
    // } catch (error) {
    //     console.log(error);
    //     return await Promise.reject(error);
    // }

    
    //' we could use sleep().then(); or we could use async await
    //sleep().then();
    
    //await sleep(1000);
    if(process.env.NODE_ENV === 'development') { //'n
        await sleep(1000);
    }

    const pagination = response.headers['pagination']; //'n //' 'pagination' it has to be with lower case becouse axios onlu work with lower case
    console.log('Ash response 1: ',  response); //.
 
    if(pagination) {
        console.log('Ash response 2: ',  response); //.
        console.log('Ash pagination: ', pagination); //.
        console.log('Ash JSON.parse(pagination: ',  JSON.parse(pagination)); //.
        console.log('Ash response.data: ',  response.data); //.

        //' update (override) response.data to =  new PaginatedResponse( and add , JSON.parse(pagination) before  return response;
        response.data = new PaginatedResponse(response.data, JSON.parse(pagination));  //'n //' class to create an new instance and passing values to the contractor
        console.log('Ash response 3: ',  response); //.
        console.log('Ash response.data 2: ',  response.data);

        const responsePaginatedResult =  response as AxiosResponse<PaginatedResponse<any>>; //.
        console.log('responsePaginatedResult: ',  responsePaginatedResult); //.

        return response as AxiosResponse<PaginatedResponse<any>>;;
    }

    return response;
//})
}, (axiosError: AxiosError) => {
    console.log("caught by interceptor!");
    //const {data, status} = axiosError.response!; //' x
    const {data, status, config, headers} = axiosError.response as AxiosResponse;

    console.log("Ash AxiosError data: ", data);

    switch(status) {
        case 400:

            if (config.method === 'get' && data.errors.hasOwnProperty('id')) {
                router.navigate('/not-faund')
            }

            toast.error('Bad request!');
            toast.error(data.title);

            if(data.errors) {
                console.log("Ash data.errors: ", data.errors);

                const modalStatErrors = [];

                for (const key in data.errors) {
                    if (data.errors[key]) {
                        modalStatErrors.push(data.errors[key]);
                    }
                }

                throw modalStatErrors.flat(); //' to flatten the array modelStateErrors[]
            } else {
                toast.error(data);
            }
            break;
        case 401: 
            //toast.error(data.title);
            toast.error('Unauthorised!');

            // ADD to CorsPolicy .WithExposedHeaders("WWW-Authenticate") //'n for RefreshToken

            //if (status === 401 && headers['www-authenticate'].startsWith('Bearer error="invalid_token"')) { //'x no ? 
            if (status === 401 && headers['www-authenticate']?.startsWith('Bearer error="invalid_token"')) { //'k
                store.userStore.logout();
                toast.error('Session expired - please login again!');
            }

            break;
        case 403: 
            toast.error('Forbidden!');
            break;
        case 404: 
            toast.error('Not found!');
            router.navigate('/not-found');
            break;
        case 500: 
            toast.error('Server error!');
            store.commonStore.setServerError(data);

            //router.navigate('/server-error', {state: {error: data}}); //.'  const {state} = useLocation();
            router.navigate('/server-error');
            break;
        // default: //'
        //     break;
        default: //.
            break;
    }

    return Promise.reject(axiosError);
})

axios.interceptors.request.use(config => { //'n >> to pass token to the request header to getUser 
    const token = store.commonStore.token;
    if(token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
})


// Example
// axios.get<Activity[]>('http://localhost:5000/api/activities').then(response => {
//   //console.log(response.data); //'
//   setActivities(response.data);
// })

//axios.defaults.baseURL = 'http://localhost:5000/api';
axios.defaults.baseURL = process.env.REACT_APP_API_URL; //'n

function responseData_(axiosResponse: AxiosResponse) { //.
    return axiosResponse.data;
}

//const responseData = (axiosResponse: AxiosResponse) => axiosResponse.data;
const responseData = <T> (axiosResponse: AxiosResponse<T>) => axiosResponse.data;

const requestMethod = {
    //get: (url: string) => axios.get(url).then(responseData),
    get: <T> (url: string) => axios.get<T>(url).then(responseData),
    post: <T> (url: string, body: {}) => axios.post<T>(url, body).then(responseData),
    put: <T> (url: string, body: {}) => axios.put<T>(url, body).then(responseData),
    del: <T> (url: string) => axios.delete<T>(url).then(responseData),
}

let activitiesController = '/activities';
const Activities = {
    //list: () => requestMethod.get('/activities') 
    //list: () => requestMethod.get<Activity[]>(activitiesController), //'o
    //list: () => requestMethod.get<PaginatedResponse<Activity[]>>(activitiesController), //'o
    //list: () => requestMethod.get<PaginatedResponse<Activity[]>>(`${activitiesController}?pageSize=${store.activityStore.pagingParams.pageSize}&pageNumber=3`), //'o
    list: (params: URLSearchParams) => axios.get<PaginatedResponse<Activity[]>>(activitiesController, {params}).then(responseData), //'n

    details: (id: string) => requestMethod.get<Activity>(`${activitiesController}/${id}`),
    //create: (activity: Activity) => requestMethod.post<void>(activitiesController, activity),
    create: (activity: ActivityFormValues) => requestMethod.post<void>(activitiesController, activity),
    //update: (activity: Activity) => requestMethod.put<void>(`${activitiesController}/${activity.id}`, activity),
    update: (activity: ActivityFormValues) => requestMethod.put<void>(`${activitiesController}/${activity.id}`, activity),
    delete: (id: string) => requestMethod.del<void>(`${activitiesController}/${id}`),
    attend: (id: string) => requestMethod.post<void>(`${activitiesController}/${id}/attend`, {}),
}

let accountController = '/account'; 
const Account = { 
    login: (userFormValues: UserFormValues) => requestMethod.post<User>(accountController + '/login', userFormValues),
    register: (userFormValues: UserFormValues) => requestMethod.post<User>(accountController + '/Register', userFormValues),
    //current: () => requestMethod.get<User>(accountController + '/GetCurrentUser'), //. x
    current: () => requestMethod.get<User>(accountController), //' k
    facebookLogin: (accessToken: string) => requestMethod.post<User>(`${accountController}/facebookLogin?accessToken=${accessToken}`, {}), //'n
    refreshToken: () => requestMethod.post<User>(`${accountController}/refreshToken`, {}), //'n
    resendEmailConfirmationLink: (email: string) => requestMethod.get<void>(`${accountController}/resendEmailConfirmationLink?email=${email}`),
    verifyEmail: (tokenEncoded: string, email: string) => requestMethod.post<void>(`${accountController}/verifyEmail?token=${tokenEncoded}&email=${email}`, {}), //'n
}

let profilesController = '/profiles'
const Profiles = {
    getProfile: (username: string) => requestMethod.get<UserActivity>(`${profilesController}/${username}`),

    //updateProfile: (profile: UserActivity) => requestMethod.post<void>(`${profilesController}/update`, profile),
    //updateProfile: (profile: ProfileFormValues) => requestMethod.post<void>(`${profilesController}/update`, profile),
    //updateProfile: (profile: Partial<UserActivity>) => requestMethod.post<void>(`${profilesController}/update`, profile), //.o
    //updateProfile: (profile: UserActivity) => requestMethod.put(`${profilesController}`, profile), //'n it works
    updateProfile: (profile: Partial<UserActivity>) => requestMethod.put(`${profilesController}`, profile), //'n
    getActivities: (username: string, predicate: string) => requestMethod.get<UserActivity2[]>(`${profilesController}/${username}/activities?predicate=${predicate}`), //'n
}

let photosController = '/photos';
const Photos = {
    uploadPhoto: (fileBlob: Blob) => {
        let formData = new FormData();
        formData.append('File', fileBlob); // it has to match the API 'File' name

        let requestUrl = axios.post<Photo>(photosController, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        console.log('Photos requestUrl: ' + requestUrl);
        return requestUrl;
    },
    setMainPhoto: (id: string) => requestMethod.post(`${photosController}/${id}/setMain`, {}),
    deletePhoto: (id: string) => requestMethod.del(`${photosController}/${id}`),
}

let followController = '/follow';
const Follow = {
    followTaggle: (username: string) => requestMethod.post(`${followController}/${username}`, {}),
    getFollowingsTaggle: (username: string, predicate: string) => requestMethod.get<UserActivity[]>(`${followController}/${username}?predicate=${predicate}`)
}

const agent = {
    Activities,
    Account, 
    Profiles,
    Photos,
    Follow,
}

export default agent;

